import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule, CheckboxModule, InputModule, RadioModule, SelectModule, TextareaModule } from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentationInternationalForm, DocumentationInternationalFormGroup } from '../../../models/cod-create.model';
import { AttachmentsInputComponent } from '../../../../shared/components/attachments-input/attachments-input.component';
import { DocumentationIssue } from '@cod-monorepo/interfaces';
import { DocumentationErrorType } from '@cod-monorepo/interfaces';
import { tap } from 'rxjs';
import { Store } from '@ngxs/store';
import { AddCurrentCodLine, AddErrorMessage, RemoveErrorMessage } from '../../../state/cod.action';
import { WorkflowError } from '../../../../shared/enums/workflow-error';
import { BaseInternationalStep } from '../base-international-step/base-international-step';

@Component({
    selector: 'app-cod-documentation-international-step',
    templateUrl: './documentation-international.component.html',
    imports: [
        CommonModule,
        SelectModule,
        InputModule,
        FormsModule,
        ReactiveFormsModule,
        RadioModule,
        CheckboxModule,
        ButtonModule,
        TextareaModule,
        AttachmentsInputComponent
    ],
    standalone: true
})
export class CodDocumentationInternationalStepComponent extends BaseInternationalStep implements OnInit {
    @Input() documentationInternationalForm: FormGroup<DocumentationInternationalFormGroup> | undefined;

    public documentationIssues = DocumentationIssue;
    public documentationErrorTypes = DocumentationErrorType;

    public showDocumentationIssueOther = false;
    public showDocumentationErrorTypeOther = false;

    constructor(private store: Store) {
        super();
    }

    ngOnInit(): void {
        this.initDocumentationIssueListener();
        this.initDocumentationErrorTypeListener();
    }

    public isDefined(control: keyof DocumentationInternationalForm): boolean {
        return this.documentationInternationalForm?.controls[control].value !== null;
    }

    public isTrue(control: keyof DocumentationInternationalForm): boolean {
        return this.documentationInternationalForm?.controls[control].value === true;
    }

    public isFalse(control: keyof DocumentationInternationalForm): boolean {
        return this.documentationInternationalForm?.controls[control].value === false;
    }

    public handleConfirm() {
        if (this.documentationInternationalForm?.valid) {
            this.store.dispatch(new AddCurrentCodLine());
        }
    }

    public isValid(): boolean {
        return this.documentationInternationalForm?.valid ?? false;
    }

    private initDocumentationIssueListener(): void {
        this.documentationInternationalForm?.controls.documentationIssue.valueChanges
            .pipe(
                tap(value => {
                    this.showDocumentationIssueOther = value === DocumentationIssue.OTHER;

                    this.store.dispatch(
                        value === DocumentationIssue.MISSING
                            ? new AddErrorMessage(WorkflowError.CONTACT_GLSC)
                            : new RemoveErrorMessage(WorkflowError.CONTACT_GLSC)
                    );
                })
            )
            .subscribe();
    }

    public initDocumentationErrorTypeListener(): void {
        this.documentationInternationalForm?.controls.documentationErrorType.valueChanges
            .pipe(tap(value => (this.showDocumentationErrorTypeOther = value === DocumentationErrorType.OTHER)))
            .subscribe();
    }
}
